/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/page-faqs/page-faqs.js":
/*!******************************************************!*\
  !*** ./zrc/scripts/templates/page-faqs/page-faqs.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! hequalizer */ \"./node_modules/hequalizer/hequalizer.min.js\");\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hequalizer__WEBPACK_IMPORTED_MODULE_0__);\n/* provided dependency */ var $ = __webpack_require__(/*! jquery */ \"./node_modules/jquery/dist/jquery.js\");\n\nclass CategoryFaqs extends window.HTMLElement {\n  constructor() {\n    super();\n    this.$section = this;\n    this.faqsTabs();\n    this.faqsAccordions();\n    this.categoriesHeight();\n    this.attachListeners();\n  }\n  focusTabClicked(tab) {\n    const $containerScrollable = this.$section.querySelector(\".main-page-faqs-navigation\");\n    $containerScrollable.scrollTo({\n      left: tab.offsetLeft,\n      behavior: \"smooth\"\n    });\n  }\n  faqsTabs() {\n    const myTabs = document.querySelectorAll(\".main-page-faqs-navigation-item\");\n    const myTabClicks = tabClickEvent => {\n      for (let i = 0; i < myTabs.length; i++) {\n        myTabs[i].classList.remove(\"is-active\");\n      }\n      const clickedTab = tabClickEvent.currentTarget;\n      clickedTab.classList.add(\"is-active\");\n      tabClickEvent.preventDefault();\n      const myContentPanes = document.querySelectorAll(\".main-page-faqs-navigation-content\");\n      for (let i = 0; i < myContentPanes.length; i++) {\n        myContentPanes[i].classList.remove(\"is-active\");\n      }\n      const anchorReference = tabClickEvent.target;\n      const activePaneId = anchorReference.getAttribute(\"href\");\n      const activePane = document.querySelector(activePaneId);\n      activePane.classList.add(\"is-active\");\n      this.focusTabClicked(anchorReference);\n    };\n    for (let i = 0; i < myTabs.length; i++) {\n      myTabs[i].addEventListener(\"click\", myTabClicks);\n    }\n  }\n  faqsAccordions() {\n    $(\".main-page-faqs-question\").on(\"click\", event => {\n      const currentElement = event.currentTarget;\n      $(\".main-page-faqs-indicator.is-active\").removeClass(\"is-active\");\n      if ($(\".main-page-faqs-answer\").is(\":visible\")) {\n        $(\".main-page-faqs-answer\").slideUp(300);\n      }\n      if ($(currentElement).next(\".main-page-faqs-answer\").is(\":visible\")) {\n        $(currentElement).next(\".main-page-faqs-answer\").slideUp(300);\n      } else {\n        $(currentElement).next(\".main-page-faqs-answer\").slideDown(300);\n        $(currentElement).children(\".main-page-faqs-indicator\").addClass(\"is-active\");\n      }\n    });\n  }\n  categoriesHeight() {\n    const $categories = this.$section.querySelectorAll(\".main-page-faqs-navigation-item\");\n    new (hequalizer__WEBPACK_IMPORTED_MODULE_0___default())($categories, {});\n  }\n  onBlockSelect(event) {\n    const $block = event.srcElement;\n    if ($block.classList.contains(\"main-page-faqs-question\")) {\n      const $indicator = $block.querySelector(\".main-page-faqs-indicator\");\n      if ($indicator.classList.contains(\"is-active\")) {\n        return;\n      }\n      const $tabWrapper = $block.closest(\".main-page-faqs-navigation-content\");\n      this.container.querySelector(`.main-page-faqs-navigation-item[href=\"#${$tabWrapper.id}\"]`).click();\n    }\n    $block.click();\n  }\n  attachListeners() {\n    document.addEventListener(\"shopify:block:select\", this.onBlockSelect.bind(this));\n  }\n}\nwindow.customElements.define(\"main-page-faqs-section\", CategoryFaqs);\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/templates/page-faqs/page-faqs.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"main-page-faqs": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/page-faqs/page-faqs.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;